import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, Validators,FormBuilder} from '@angular/forms'
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {AnalyticsService} from '../dashboard/analytics.service';

@Component({
  selector: 'app-dashboard-login',
  templateUrl: './dashboard-login.component.html',
  styleUrls: ['./dashboard-login.component.css']
})
export class DashboardLoginComponent implements OnInit {

  loginForm: FormGroup;
  error:string;
  logging = false;
  loginButton = "Login";
  constructor(private fb:FormBuilder, private router:Router, private authenticationService:AuthenticationService, private analyticsService:AnalyticsService) { }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email : ['', Validators.compose([Validators.required, Validators.minLength(3),Validators.maxLength(100), Validators.pattern('^[a-zA-Z0-9]+(.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,15}( )*?)$')]) ],
      password: ['']
    });
  }
  onLogin(form){
    this.loginButton = "logging in";
    this.authenticationService.login(form.value.email, form.value.password)
      .subscribe(
        data => {
          this.analyticsService.getAuthorization()
            .subscribe(
              data =>{
                if(data.authority!="Unauthorized"){
                  this.router.navigate(['/dashboard']);
                }else{
                  this.loginButton = "Login";
                  this.router.navigate(['/login']);
                }
              }
            )
        },
        error => {
          this.loginButton = "Login";
          this.router.navigate(['/login']);
        }
      )


  }

}
